'use client';

import { cn } from '@noirproperties/ui/lib/utils';
import {
  APIProvider,
  Map as GoogleMap,
  Marker as GoogleMarker,
} from '@vis.gl/react-google-maps';
import { styles } from './map.styles';

type MapProps = {
  apiKey: string;
  position: {
    latitude: number;
    longitude: number;
  };
  zoom?: number;
  className?: string;
  children?: React.ReactNode;
};

export function Map({
  apiKey,
  position,
  zoom = 7,
  className,
  children,
}: MapProps) {
  return (
    <APIProvider apiKey={apiKey}>
      <div className={cn('h-96', className)}>
        <GoogleMap
          center={{ lat: position.latitude, lng: position.longitude }}
          disableDefaultUI
          styles={styles.hiding}
          zoom={zoom}
        >
          {children}
        </GoogleMap>
      </div>
    </APIProvider>
  );
}

type MarkerProps = {
  position: MapProps['position'];
};

export function Marker({ position }: MarkerProps) {
  return (
    <GoogleMarker
      position={{ lat: position.latitude, lng: position.longitude }}
    />
  );
}
